(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    section.dataset.depictInit = '1';

    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');

    // Sets data-depict-overflow when the row scrolls (drives arrow visibility)
    // and the nav-button disabled state. Skipped while display:none
    // (clientWidth 0); the ResizeObserver re-runs it once the Depict extension
    // reveals the section.
    function update() {
      if (!grid.clientWidth) return;
      var max = grid.scrollWidth - grid.clientWidth;
      var hasOverflow = max > 1;
      var sl = Math.abs(grid.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (hasOverflow) {
        section.setAttribute('data-depict-overflow', '');
      } else {
        section.removeAttribute('data-depict-overflow');
      }
    }

    // No behavior key: the grid's CSS scroll-behavior decides smooth vs instant,
    // so prefers-reduced-motion is honored without JS.
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9 });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });

    grid.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(grid);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      //this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-select', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.enable = this.getAttribute('data-enable-reveal') === 'true' ? true : false;

      if (this.enable) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-collection-faq"] && !Shopify.designMode) return;
  try {
    
  class CollectionFaq extends HTMLElement {
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      for (const item of this.querySelectorAll('details.collection-faq__item')) {
        const summary = item.querySelector('summary');
        if (!summary) continue;

        summary.addEventListener('click', (event) => this.#onSummaryClick(event, item), { signal });
      }
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    #onSummaryClick(event, details) {
      event.preventDefault();
      if (details.dataset.animating === 'true') return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        details.open = !details.open;
        return;
      }

      details.open ? this.#collapse(details) : this.#expand(details);
    }

    #expand(details) {
      const panel = details.querySelector('.collection-faq__panel');
      if (!panel) return;

      details.dataset.animating = 'true';
      details.setAttribute('open', '');

      const height = panel.scrollHeight;
      panel.style.height = '0px';
      void panel.offsetHeight;
      panel.style.height = `${height}px`;

      this.#onHeightEnd(panel, () => {
        panel.style.height = '';
        delete details.dataset.animating;
      });
    }

    #collapse(details) {
      const panel = details.querySelector('.collection-faq__panel');
      if (!panel) return;

      details.dataset.animating = 'true';
      panel.style.height = `${panel.scrollHeight}px`;
      void panel.offsetHeight;
      panel.style.height = '0px';

      this.#onHeightEnd(panel, () => {
        details.removeAttribute('open');
        panel.style.height = '';
        delete details.dataset.animating;
      });
    }

    #onHeightEnd(panel, callback) {
      const onEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        callback();
      };

      panel.addEventListener('transitionend', onEnd);
    }
  }

  if (!customElements.get('collection-faq')) {
    customElements.define('collection-faq', CollectionFaq);
  }

  } catch(e) { console.error(e); }
})();
})();
